import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import api from "@/api/users";

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async overview(params: any) {
    return api.overview(params);
  }

  @Action
  async getUsers(params: any) {
    return api.getUsers(params);
  }

  @Action
  async detail(params: any) {
    return api.detail(params);
  }

  @Action
  async playbill(params: any) {
    return api.playbill(params);
  }

  @Action
  async orderbill(params: any) {
    return api.orderbill(params);
  }

  @Action
  async otherbill(params: any) {
    return api.otherbill(params);
  }

  @Action
  async memberpics(params: any) {
    return api.memberpics(params);
  }

  @Action
  async services(params: any) {
    return api.services(params);
  }

  @Action
  async servicedetail(params: any) {
    return api.servicedetail(params);
  }

  @Action
  async credits(params: any) {
    return api.credits(params);
  }

  @Action
  async player(params: any) {
    return api.player(params);
  }

  @Action
  async aiPlayer(params: any) {
    return api.aiPlayer(params);
  }

  @Action
  async aiPlayerLog(params: any) {
    return api.aiPlayerLog(params);
  }

  @Action
  async contact(params: any) {
    return api.contact(params);
  }

  @Action
  async makeAGroup(params: any) {
    return api.makeAGroup(params);
  }

  @Action
  async activities(params: any) {
    return api.activities(params);
  }

  @Action
  async vipcard(params: any) {
    return api.vipcard(params);
  }

  @Action
  async vipcardexport(params: any) {
    return api.vipcardexport(params);
  }

  @Action
  async vipcarddetail(params: any) {
    return api.vipcarddetail(params);
  }

  @Action
  async cancelVipCard(params: any) {
    return api.cancelVipCard(params);
  }

  @Action
  async testbuy(params: any) {
    return api.testbuy(params);
  }

  @Action
  async editvipcard(params: any) {
    return api.editvipcard(params);
  }

  @Action
  async frozenmoney(params: any) {
    return api.frozenmoney(params);
  }

  @Action
  async addRequest(params: any) {
    return api.addRequest(params);
  }

  @Action
  async addRequestData(params: any) {
    return api.addRequestData(params);
  }

  @Action
  async setIsMaster(params: any) {
    return api.setIsMaster(params);
  }

  @Action
  async balanceTotal(params: any) {
    return api.balanceTotal(params);
  }

  @Action
  async coupon(params: any) {
    return api.coupon(params);
  }

  @Action
  async deposit(params: any) {
    return api.deposit(params);
  }

  @Action
  async depositCategory(params: any) {
    return api.depositCategory(params);
  }

  @Action
  async saveDepositFrozenTime(params: any) {
    return api.saveDepositFrozenTime(params);
  }

  @Action
  async setIsNoSms(params: any) {
    return api.setIsNoSms(params);
  }

}
